export default __webpack_public_path__ + "static/media/contact_us_btn_violet.32b31b67.svg";